module.exports = __webpack_public_path__ + "media/images/pepsi--medium-031d5fb3e95d98c72440680b8131845b.png";